import * as React from "react";
import { useAuth } from "@/App";
import { Logo } from "@/components/misc";
import { LogOut } from "@/components/NavBar/UI/Components/LogOut";
import { NavMain } from "@/components/NavBarRework/components/nav-main";
import { NavUserFooter } from "@/components/NavBarRework/components/nav-user";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
} from "@/components/ui/sidebar";

// Top Level Component
export function NavSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const { user } = useAuth();
	if (!user) return null;

	return (
		<Sidebar collapsible="icon" {...props}>
			<SidebarHeader>
				<Logo />
			</SidebarHeader>

			<SidebarContent>
				<NavMain items={user.nav_bar_items?.navMain || []} />
			</SidebarContent>

			<SidebarFooter>
				<NavUserFooter
					user={user.nav_bar_items?.user || { name: "", email: "", role: "" }}
				/>
			</SidebarFooter>

			<LogOut />

			<SidebarRail />
		</Sidebar>
	);
}
